import { render, staticRenderFns } from "./CondServizio.vue?vue&type=template&id=06c75799&scoped=true"
import script from "./CondServizio.vue?vue&type=script&lang=js"
export * from "./CondServizio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c75799",
  null
  
)

export default component.exports